export const SPARROW_CARD_PATH = 'https://sparrowcard.com/';
export const FOCUSABLE_TAB_INDEX = 0;
export const NON_FOCUSABLE_TAB_INDEX = -1;
